import api from "@/helpers/api";

const API_READ = `/api/member/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ
const API_REGISTER = `/api/signup`
const API_REQUEST = `/api/request-otp`
const API_SUBMIT = `/api/submit-otp`
const API_IMPORT = `${API_READ}import`;
const API_MEMBER_REGISTER = `/api/member-register/`;
const API_UPDATE_PROFILE = `/api/member/profile/`
// New member auth module endpoints
const API_MEMBER_AUTH_DEFAULT_CONTEXT = `/api/member/default-context`

export default {
    namespaced: true,
    state: {
        status: '',
        memberRegisterData: [],
        members: [],
        currUser: {},
        errMessage: '',
        meta: {
            limit: 10,
            page: 1,
            total: 1
        },
        filter: {},
        search: {

        }
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        read(state, { members }) {
            state.members = [...members]
        },
        read_single_success(state, { members }) {
            state.members = members
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter };
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        clear_search(state) {
            state.search = {};
        },
        add_single_member(state, { member }) {
            const existingIndex = state.members.findIndex(m => m.id === member.id);
            if (existingIndex === -1) {
                state.members = [member, ...state.members];
            } else {
                state.members[existingIndex] = member;
            }
        },
        export(state, { members }) {
            state.members = [...members]
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        },
        set_member_register_data(state, { members }) {
            state.memberRegisterData = [...members];
        },
    },
    actions: {
        read({ commit, state }) {

            commit('request')

            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((result) => {
                        commit('read', { members: result.data.data })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        export({ commit, state }) {

            commit('request');

            const { filter } = state

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}export`, { filter }, { responseType: 'blob' })
                    .then((result) => {
                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err)
                    });
            });
        },
        read_single({ commit }, id) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err)
                    });
            })
        },
        read_transaction_history({ commit, state }, id) {

            commit('request');

            const { meta } = state;
            const { filter } = state

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}transaction/${id}`, { meta, filter })
                    .then(res => {
                        commit('success');
                        commit('switch_page', { meta: { ...res.data.data.meta } })
                        return resolve(res.data.data);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err.response.data);
                    })
            });
        },
        delete({ commit, dispatch, state }, id) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.members.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success')
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err.response.data)
                    });
            });

        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                    .then(($request) => {
                        commit('success');
                        return resolve($request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        updateProfile({ commit }, payload) {
            commit('request');
            const dataToSend = {
                country: payload.country,
                phone: payload.phone,
            };
            const userId = payload.id;

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE_PROFILE}${userId}`, {}, dataToSend)
                    .then(($request) => {
                        commit('success');
                        return resolve($request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        create({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        register({ commit }, { data }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_REGISTER, {}, data)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        request_otp({ commit }, data) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_REQUEST, {}, data)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
        , submit_otp({ commit }, data) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_SUBMIT, {}, data)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        extranet_request_otp({ commit }, data) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', '/api/extranet/auth/request-otp', {}, data)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        extranet_submit_otp({ commit }, data) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', '/api/extranet/auth/submit-otp', {}, data)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        import({ commit }, { data }) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('post', API_IMPORT, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        all({ commit }, id) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}all/${id}`)
                    .then((result) => {
                        commit('read', { members: result.data.data })
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read_member_register({ commit, state }) {
            commit('request');

            const { meta, filter } = state;

            return new Promise((resolve, reject) => {
                api.request('get', API_MEMBER_REGISTER, { meta, filter })
                    .then((result) => {
                        commit('set_member_register_data', { members: result.data.data });
                        commit('switch_page', { meta: result.data.meta });
                        commit('success');
                        return resolve(result.data);
                    })
                    .catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        // New member auth module actions
        member_default_context({ commit }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', API_MEMBER_AUTH_DEFAULT_CONTEXT)
                    .then(res => {
                        commit('success');
                        return resolve(res);
                    }).catch(err => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
    },
    getters: {
        members: () => state => state.members,
        memberRegisterData: (state) => state.memberRegisterData,
    }
}
